
<template>
  <div class="PacientesInfoGeneral">
    <v-card outlined>
      <v-list>
        <v-list-item three-line>
          <v-list-item-avatar size="64">
            <v-img
              v-if="!paciente.foto_pac"
              src="@/assets/avatars/perfil.png"
            ></v-img>
            <v-img
              v-else
              :src="$raiz + 'uploads/imagenes/' + paciente.foto_pac"
              @click="showDialogFullFoto=true"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              class="upper"
              v-text="`${paciente.nombre_pac} ${paciente.ape_pat_pac} ${paciente.ape_mat_pac}`"
            />
            <v-list-item-subtitle v-text="'Género: '+paciente.genero_pac" />
            <v-list-item-subtitle v-text="edad+' años de edad'" />
            <v-list-item-subtitle
              class="upper"
              v-if="edad <18"
              v-text="paciente.tipo_tutor_pac+', '+paciente.nombre_tutor_pac"
            />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-dialog v-model="showDialogFullFoto">
      <v-card>
        <v-card-title>
          <v-btn
            icon
            @click="showDialogFullFoto=false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          {{paciente.nombre_pac+' '+paciente.ape_pat_pac+' '+paciente.ape_mat_pac}}
        </v-card-title>
        <v-img
          aspect-ratio="1"
          :src="$raiz + 'uploads/imagenes/' + paciente.foto_pac"
        ></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
export default {
  name: "PacientesInfoGeneral",
  mixins: [forms],
  props: {
    id: String, //id del paciente
  },
  data() {
    return {
      paciente: {},
      showDialogFullFoto: false,
    };
  },
  methods: {
    _getPaciente() {
      if (this.id) {
        this._getThings("pacientes/" + this.id, "paciente");
      }
    },
  },
  created() {
    this._getPaciente();
  },
  computed: {
    edad() {
      if (!this.paciente.fecha_nac_pac) return 0;
      var fecha = this.$Datetime.fromISO(this.paciente.fecha_nac_pac);
      var { years } = this.$Datetime.local().diff(fecha, "years").toObject();
      return Math.floor(years);
    },
  },
  watch: {
    id(a) {
      this._getPaciente();
    },
  },
};
</script>

